export default __webpack_public_path__ + "static/media/oyuncumarket.8d0ad871.png";